import { Controller } from "stimulus"

function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.content : ''
}

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    this.loadPreference()
  }

  async loadPreference() {
    try {
      const response = await fetch('/learning_options/progress', {
        headers: { 'Accept': 'application/json' }
      })
      if (response.ok) {
        // Just ensure the button state matches the hidden input
        const isEnabled = this.inputTarget.value === "true"
        this.buttonTarget.classList.toggle("active", isEnabled)
      }
    } catch (e) {
      // Silently fail - preference loading is optional
    }
  }

  toggle() {
    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()
    this.buttonTarget.classList.toggle("active", !isEnabled)

    // Save preference to server
    this.savePreference(!isEnabled)

    // Toggle sidebar panel if it exists
    this.toggleSidebarPanel(!isEnabled)
  }

  async savePreference(enabled) {
    try {
      await fetch('/learning_options/toggle', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({ enabled })
      })
    } catch (e) {
      console.error('Failed to save learning preference:', e)
    }
  }

  toggleSidebarPanel(enabled) {
    const sidebarPanel = document.getElementById('learning-sidebar-panel')
    if (sidebarPanel) {
      if (enabled) {
        sidebarPanel.classList.remove('d-none')
        this.loadSidebarContent()
      } else {
        sidebarPanel.classList.add('d-none')
      }
    }
  }

  async loadSidebarContent() {
    const sidebarPanel = document.getElementById('learning-sidebar-panel')
    if (!sidebarPanel) return

    try {
      const response = await fetch('/learning_options', {
        headers: { 'Accept': 'text/html' }
      })
      if (response.ok) {
        const html = await response.text()
        sidebarPanel.innerHTML = html
      }
    } catch (e) {
      console.error('Failed to load learning sidebar:', e)
    }
  }
}
